import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {DevilsCrossRoadSound} from "../sound/DevilsCrossRoadSound";


export class FreespinCollectorView extends PIXI.Container {
    name:string = "FreespinCollectorView";

    private currentValue: number = 0;
    private textStyle:PIXI.TextStyle = new PIXI.TextStyle(
        {
            fill : 0x00BFFF,
            fontFamily : OpenSans.FAMILY,
            wordWrap : false,
            fontWeight : FontWeight.BOLD,
            fontSize : 22
    });
    private fsMeter: PIXI.spine.Spine;

    constructor() {
        super();

        this.createCollectIndicator();
        this.onOrientationChanged();
        this.hide();
    }

    private createCollectIndicator():void {
        this.fsMeter = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("fsMeter"));

        //console.log("FS METER animations", this.fsMeter.state.data.skeletonData.animations);

        this.addChild(this.fsMeter);
    }

    public playAnimation(animName:string, colValue?:number): gsap.core.Timeline {

        /*
            Animation {name: 'collect_1', timelines: Array(1), timelineIds: Array(67108869), duration: 0}
            Animation {name: 'collect_1_transition', timelines: Array(14), timelineIds: Array(83886092), duration: 0.833299994468689}
            Animation {name: 'collect_2', timelines: Array(1), timelineIds: Array(67108868), duration: 0}
            Animation {name: 'collect_2_transition', timelines: Array(17), timelineIds: Array(83886092), duration: 0.833299994468689}
            Animation {name: 'collect_3', timelines: Array(1), timelineIds: Array(67108867), duration: 0}
            Animation {name: 'collect_3_transition', timelines: Array(20), timelineIds: Array(83886092), duration: 0.833299994468689}
            Animation {name: 'collect_4', timelines: Array(1), timelineIds: Array(67108866), duration: 0}
            Animation {name: 'collect_4_transition', timelines: Array(21), timelineIds: Array(83886092), duration: 0.8666999936103821}
            Animation {name: 'collect_full', timelines: Array(24), timelineIds: Array(83886094), duration: 1.4666999578475952}
            Animation {name: 'empty', timelines: Array(0), timelineIds: Array(0), duration: 0}
            Animation {name: 'sfs_transition', timelines: Array(22), timelineIds: Array(83886090), duration: 1.0666999816894531}
         */

        let collectString:string = (colValue)? "collect_" + colValue : "collect_";
        let trackIndex:number = 0;
        let animation:PIXI.spine.core.Animation = this.fsMeter.spineData.findAnimation("empty");
        let animationAlpha:number = 1;
        let mixDuration:number = 0;


        const tl: gsap.core.Timeline = gsap.timeline();

        switch (animName) {
            case "empty":
                trackIndex = 0;
                animation = this.fsMeter.spineData.findAnimation("empty");
                animationAlpha= 1;
                mixDuration = 0;

                tl.add(() => SpineGSAPWrapper.setAnimation(this.fsMeter, trackIndex, animation, false, animationAlpha, mixDuration));
                break;

            case "collect":
                trackIndex = 0;
                collectString = (colValue)? "collect_" + colValue : "collect_";
                animation = this.fsMeter.spineData.findAnimation(collectString);
                animationAlpha = 1;
                mixDuration = 0;

                if(colValue && colValue < 5) {
                    tl.add(() => SpineGSAPWrapper.setAnimation(this.fsMeter, trackIndex, animation, false, animationAlpha, mixDuration));
                }
                break;

            case "transition":
                trackIndex = 0;
                collectString = (colValue)? "collect_" + colValue + "_transition" : "collect_";
                animation = this.fsMeter.spineData.findAnimation(collectString);
                animationAlpha = 1;
                mixDuration = 0;

                tl.add(() => {
                    SpineGSAPWrapper.setAnimation(this.fsMeter, trackIndex, animation, false, animationAlpha, mixDuration);
                    if(colValue){
                        DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_PROGRESS_METER_LEVEL[colValue-1]});
                    }
                });
                break;

            case "full":
                trackIndex = 0;
                collectString = (colValue)? "collect_" + colValue : "collect_full";
                animation = this.fsMeter.spineData.findAnimation(collectString);
                animationAlpha = 1;
                mixDuration = 0;

                tl.add(() => {
                    SpineGSAPWrapper.setAnimation(this.fsMeter, trackIndex, animation, false, animationAlpha, mixDuration);
                    DevilsCrossRoadSound.soundPlayer.playTrack({name:DevilsCrossRoadSound.SFS_FEATURE_ROW_UNLOCKED});
                });
                tl.add(() => {}, 1.4666999578475952);
                break;

            case "sfs":
                trackIndex = 0;
                animation = this.fsMeter.spineData.findAnimation("sfs_transition");
                animationAlpha= 1;
                mixDuration = 0;

                tl.add(() => SpineGSAPWrapper.setAnimation(this.fsMeter, trackIndex, animation, false, animationAlpha, mixDuration));
                break;


        }

        return tl;
    }

    public onOrientationChanged() {
        if(NolimitApplication.isLandscape) {
            this.fsMeter.position.set(655, 450);
        }
        else {
            this.fsMeter.position.set(667.5, 410);
        }
    }

    public getNextCollectAnimation(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        switch(this.currentValue) {

        }

        return tl;
    }

    public updateCollect(val:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();


        if(val && val > this.currentValue) {
            this.currentValue = val;

            //let tlp:gsap.core.Timeline = gsap.timeline();
            tl.add(this.playAnimation("transition", this.currentValue));
            tl.add(this.playAnimation("collect", this.currentValue), 0.833299994468689);
        }

        return tl;
    }
    public show(startVal:number):void {
        this.visible = true;

        this.currentValue = startVal;
        if(startVal > 0) {
            this.playAnimation("collect", this.currentValue);
        }
        else {
            this.playAnimation("empty");
        }

    }

    public hide():void {
        this.currentValue = 0;
        this.visible = false;
        this.playAnimation("empty");
    }
}